import React from "react";
import { Avatar, AvatarImage } from "@/components/ui/avatar";

interface AvatarGroupProps {
  images: string[];
  size?: number; 
}

const AvatarGroup = React.forwardRef<HTMLDivElement, AvatarGroupProps>(
  ({ images, size = 32 }, ref) => {
    const overlap = Math.floor(size / 3); // Controls the overlap amount

    return (
      <div ref={ref} className="flex items-center">
        {images.map((src, index) => (
          <div
            key={index}
            style={{
              width: size,
              height: size,
              marginLeft: index === 0 ? 0 : -overlap,
              zIndex: images.length - index,
            }}
            className="rounded-full shadow-avatargroup border border-white"
          >
            <Avatar className="w-full h-full">
              <AvatarImage src={src} alt={`Avatar ${index + 1}`} />
            </Avatar>
          </div>
        ))}
      </div>
    );
  }
);

AvatarGroup.displayName = "AvatarGroup"; 

export default AvatarGroup;
